<template>
  <div class="entity-search">
    <div v-if="validationErrorMessages.length" class="text-center">
      <h4>Invalid Entity Search Request</h4>
      <div class="text-danger" v-for="(message, i) in validationErrorMessages" :key="i">
        {{ message }}
      </div>
    </div>
    <div v-if="isLoading">
      Search Entity in progress...
    </div>
  </div>
</template>

<script>
import { get } from '@/utils/Api'
import UrlStore from '@/utils/UrlStore'

export default {
  name: 'EntitySearch',
  data: () => ({
    isLoading: false,
    validationErrors: {}
  }),
  computed: {
    validationErrorMessages() {
      return Object.values(this.validationErrors).flat() ?? []
    },
    pointSearchParams() {
      return this.$route.query
    }
  },
  methods: {
    async tryFindPoint() {
      try {
        this.isLoading = true
        this.validationErrors = {}
        const { data: point } = await get(UrlStore.POINTS_ENTITY_SEARCH, { params: this.pointSearchParams })
        if (point) {
          this.$router.push({ name: 'map', params: { floorId: point.floor_id }, query: { pointId: point.id } })
        } else {
          this.$set(this, 'validationErrors', { point: 'Entity not found!' })
        }
      } catch (error) {
        if (error.response?.status === 422) {
          this.$set(this, 'validationErrors', error.response.data.errors)
        } else {
          throw error
        }
      } finally {
        this.isLoading = false
      }
    }
  },
  mounted() {
    this.tryFindPoint()
  }
}
</script>

<style scoped>
.entity-search {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
